'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useCurrentUser } from '@paeffgen/react/crm-documents/feature-auth';

/**
 * Synchronisiert den eingeloggten Keycloak-User mit dem Sentry-Scope.
 *
 * Folgen:
 *  - "Fehler melden"-Formular: Name + E-Mail werden vorausgefüllt
 *    (Default-Mapping useSentryUser = { email: 'email', name: 'username' }
 *     in instrumentation-client.ts → username = Anzeigename).
 *  - Alle Error-Events / Session-Replays werden dem Kunden zugeordnet.
 *
 * Rendert nichts; liegt innerhalb des SessionProvider (siehe providers.tsx).
 */
export function SentryUserSync(): null {
  const { user, isAuthenticated } = useCurrentUser();

  useEffect(() => {
    if (isAuthenticated && user) {
      Sentry.setUser({
        id: user.sub || undefined,
        email: user.email,
        username: user.name, // landet im Formularfeld "Name"
      });
    } else {
      Sentry.setUser(null); // Scope bei Logout leeren
    }
  }, [isAuthenticated, user]);

  return null;
}
